import { useTranslation } from 'core/i18n';
import { ExtendedValidationMessages } from 'commons/components';
import { PredefinedCommentFormModel } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.model';

export const usePredefinedCommentErrorMessagesForm = () => {
    const { t } = useTranslation();
    const errorMessages: Partial<
        Record<keyof Pick<PredefinedCommentFormModel, 'commentText'>, ExtendedValidationMessages>
    > = {
        commentText: {
            error: {
                'value-missing': t('settings.devices.predefined-comments.form.errors.comment-text.value-missing'),
                duplicated: t('settings.devices.predefined-comments.form.errors.comment-text.duplicated'),
                'too-long': t('settings.devices.predefined-comments.form.errors.comment-text.too-long'),
            },
        },
    };

    return { errorMessages };
};
